module.exports = __webpack_public_path__ + "static/media/FUN88_Affiliate_Page_Icons_telegram.e6996fcc.svg";